import Content, {ContentProps, Ref} from '@pages/front/components/Content';
import {Button} from 'antd';
import IconFont from '@/common/IconFont';
import {getColumns} from '@pages/front/pages/permission/const';
import {delRole, getRolePage} from '@/service/permission';
import {useEffect, useRef} from 'react';
import {useRouter} from '@hooks/hooks';
import layer from '@/utils/layer';

const PermissionMana = () => {
  const router = useRouter();
  const ref = useRef<Ref>();
  const personMenu = (prop: RoleMana) => {
    sessionStorage.setItem('perMemberRoleName', prop.name);
    router.to(`/front/permission/permissionMember?roleId=${prop.id}`);
  };

  const oprRole = (prop?: RoleMana) => {
    let string = '/front/permission/';
    if (prop) {
      string = string + `editPerTree?id=${prop.id}`;
    } else {
      string = string + 'addPerTree';
    }
    router.to(string);
  };

  const deleteFn = (p: RoleMana) => {
    layer.confirm({
      title: '提示',
      content: `确认将${p.name}移除？`,
      onOk: async () => {
        await delRole(Number(p.id));
        ref.current?.search();
      }
    });
  };

  useEffect(() => {
    sessionStorage.removeItem('perMemberRoleName');
  }, []);

  const config: ContentProps = {
    title: '权限管理',
    header: {
      type: ['card']
    },
    searchProps: [
      {
        type: 'input',
        field: 'roleNameLike',
        placeholder: '角色名称',
        width: 220
      }
    ],
    initFn: getRolePage,
    tableProps: {
      columns: getColumns(personMenu, oprRole, deleteFn),
      actionBtns: [
        <Button key="添加角色" type="primary" icon={<IconFont style={{color: '#fff'}} type="icon-tianjia" />} onClick={() => oprRole()}>添加角色</Button>
      ]
    }
  };
  return (<>
    <Content ref={ref} {...config}></Content>
  </>
  );
};
export default PermissionMana;
